"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var isBrowser = !(Object.prototype.toString.call(global.process) === "[object process]" && !global.process.browser);
var mapboxgl = isBrowser ? require("mapbox-gl") : null;
var _default = mapboxgl;
exports["default"] = _default;